import UserStore from '../../stores/UserStore'

import backendApis from '../../utils/backendApis'

class Initialize {
  isUpdating = false

  init = async (tokenTemp) => {
    // 한 번 접속 당 돌리는 함수
    if (this.isUpdating) {
      return
    }

    this.isUpdating = true

    const userData = await backendApis.loadWebUserData()
    UserStore.setUserInfo(userData?.data)

    return true
  }

  loadBasicInfo = async (tokenTemp) => {
    // 접속 시 + 디비 리로드 시 돌리는 함수

    // 유저 정보 로드
    const userData = await backendApis.loadWebUserData()

    // 스탑 플래그
    if (!(userData?.status === 200 && userData?.data)) {
      return false
    }

    // 전역 상태에 저장
    UserStore.setUserInfo(userData?.data)

    return true
  }
}

export default new Initialize()
